module.exports = __webpack_public_path__ + "img/inu_main2.c090b1e8.jpg";